import { useMemo } from 'react'
import { deleteCookie } from 'src/utils/cookies'

interface UseDelayedStartTimeParams {
  delayMinutes?: number
  durationMinutes?: number
  cookieName?: string
  createdAt: number
}

export function useDelayedStartTime({
  delayMinutes = 10,
  durationMinutes = 20,
  cookieName = 'pixPaymentReminderTrigger',
  createdAt,
}: UseDelayedStartTimeParams): {
  toastStartTime: number | null
  delay: number
  isReady: boolean
} {
  return useMemo(() => {
    if (!createdAt || Number.isNaN(createdAt)) {
      deleteCookie(cookieName)

      return { toastStartTime: null, delay: 0, isReady: false }
    }

    const delayMs = delayMinutes * 60 * 1000
    const durationMs = durationMinutes * 60 * 1000
    const now = Date.now()
    const timePassed = now - createdAt

    if (timePassed >= durationMs) {
      return { toastStartTime: null, delay: 0, isReady: false }
    }

    if (timePassed >= delayMs) {
      return { toastStartTime: now, delay: 0, isReady: true }
    }

    const startTime = createdAt + delayMs

    return { toastStartTime: startTime, delay: startTime - now, isReady: false }
  }, [delayMinutes, durationMinutes, createdAt, cookieName])
}
